import React from 'react';
import { Spinner } from 'react-bootstrap';


const ButtonLoader: React.FC = () => {

    return (
        <>
            <div className="wrapper">
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>

        </>
    );
};

export default ButtonLoader;
